/**
 * Lumereh Design System — shared scroll-reveal.
 * Fades/rises any [data-reveal] element into view once, the first time it
 * enters the viewport. Group repeating items (category tiles, product
 * cards, feature columns) inside a [data-reveal-group] container to get a
 * staggered entrance instead of everything appearing at once — see the
 * nth-child delays in lumereh-tokens.css.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var elements = document.querySelectorAll('[data-reveal]');
  if (!elements.length) return;

  if (!('IntersectionObserver' in window)) {
    elements.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elements.forEach(function (el) {
    observer.observe(el);
  });
})();
